function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  padding: PropTypes.number,
  labelHeight: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};
var defaultProps = {
  padding: 10
};

var RulerTooltip = function (_Component) {
  _inherits(RulerTooltip, _Component);

  function RulerTooltip() {
    var _temp, _this, _ret;

    _classCallCheck(this, RulerTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      textWidth: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RulerTooltip.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var textBBox = this.textRef.getBBox(); // we can't know in advance the text width has been already set
    // so as far as it is synchronous operation we can run setState
    // right after all the sync operations finish

    setTimeout(function () {
      return _this2.setState({
        textWidth: textBBox.width
      });
    });
  };

  RulerTooltip.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        labelHeight = _props.labelHeight,
        color = _props.color,
        label = _props.label,
        x = _props.x,
        y = _props.y,
        padding = _props.padding,
        width = _props.width;
    var xTranslate = x + padding + this.state.textWidth > width ? x - padding - padding - this.state.textWidth : x + padding;
    return React.createElement('g', {
      transform: 'translate(' + xTranslate + ', ' + y + ')',
      style: {
        cursor: 'default'
      },
      className: 'ruler-tooltip'
    }, React.createElement('rect', {
      className: 'ruler-tooltip-fill',
      fill: 'white',
      width: this.state.textWidth + padding,
      height: labelHeight,
      stroke: color,
      strokeWidth: '1',
      strokeOpacity: '0.5',
      opacity: '0.9',
      rx: 3,
      ry: 3
    }), React.createElement('text', {
      className: 'ruler-tooltip-text',
      textAnchor: 'middle',
      alignmentBaseline: 'central',
      x: (this.state.textWidth + padding) / 2,
      y: labelHeight / 2,
      ref: function ref(_ref) {
        _this3.textRef = _ref;
      },
      style: {
        fontSize: '14px',
        color: '#333333',
        fill: '#333333'
      }
    }, label));
  };

  return RulerTooltip;
}(Component);

RulerTooltip.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
RulerTooltip.defaultProps = defaultProps;
export default RulerTooltip;